import {iso6391ToIso6392, iso6392ToIso6391} from "../../../../utils/helpers"

export default {
	data: function () {
		return {
			entityName: 'message',
			moduleName: 'messages',
			detailPageRouteName: 'messageDetail',
			updateFields: [
				'name',
				'type',
				'force_confirmation',
				'timer',
				'translations',
				'recipients_count',
				'user_created',
				'time_validity',
				'recipients',
				'combine_recipients_conditions',
				'id_message_template',
				'operator_id'
		],
			datetimeFields: [
				'time_validity',
			],
			entity: {
				name: null,
				type: 'info',
				force_confirmation: false,
				timer: null,
				time_validity: null,
				date_created: null,
				recipients_count: 0,
				user_created: null,
				translations: {},
				id_operator: null,
				combine_recipients_conditions: false,
				recipients: {
					id_subscribers: [],
					subscriber_type: null,
					id_subscriber_tags: [],
					id_services: [],
					id_channel_packages: [],
					id_device_types: [],
					id_brands: [],
					id_operators: [],
				}
			},
			translation: {
				language: this.$language.current,
				subject: '',
				short_body: '',
				body: ''
			},
			isGlobal: false,
			sendToAll: false,
			combineConditions: false,
			selectedLanguageId: null,
			popupRecipientsData: null,
			messageParams: null,
			popupSaveAsTemplateData: null,
			finishRedirectRedirect: null,
			finishRedirectData: null,
			subscriberTypes: [],
			recipientsCount: 0,
		}
	},
	computed: {
		type() {
			let type = this.messageTypeOptions.find(o => o.id === this.entity.type)
			return type.text
		},
		isGlobalComputed: {
			get() {
				return this.entity.id_operator === null
			},
			set(newValue) {
				if (newValue) {
					this.entity.id_operator = null
				} else {
					this.getOperatorsAndSetIdOperatorToEntity()
				}
			}
		},
		selectedOperatorId() {
			return this.$store.getters.getSelectedOperatorId ? this.$_loggedUser_operatorId : this.$store.getters.getSelectedOperatorId;
		},
		operatorIdComputed: {
			get() {
				return this.entity.id_operator
			},
			set(newValue) {
				this.entity.id_operator = newValue
			}
		},
		getOperatorsIds() {
			return this.$store.getters.getSelectedOperatorId;
		},
	},
	methods: {
		_beforeCreateEntityActions(params = null) {
			let translations = this.prepareTranslationsForEntityActions(params)

			let data = {
				name: this.entity.name,
				type: this.entity.type,
				force_confirmation: this.entity.force_confirmation,
				timer: (isNaN(parseInt(this.entity.timer))) ? null : parseInt(this.entity.timer),
				time_validity: this.entity.time_validity,
				translations: translations,
				combine_recipients_conditions: this.combineConditions
			}

			if (this.$route.params.id_template) {
				data.id_message_template = (isNaN(parseInt(this.$route.params.id_template))) ? null : parseInt(this.$route.params.id_template)
			}

			if (!this.sendToAll) {
				data.recipients = this.entity.recipients;
			}

			return data
		},
		prepareTranslationsForEntityActions(params = null) {
			let translations = {}
			for (const key in params.translations) {
				let translation = params.translations[key]
				let lang = iso6391ToIso6392(key)
				translations[lang] = {
					"subject": translation.subject,
					"short_body": translation.short_body,
					"body": translation.body
				}
			}
			return translations
		},
		_afterGetEntityActions() {
			let translations = {}
			let firstLanguage = null
			for (const key in this.entity.translations) {
				let translation = this.entity.translations[key]
				let lang = iso6392ToIso6391(key)
				translations[lang] = {
					"subject": translation.subject,
					"short_body": translation.short_body,
					"body": translation.body
				}

				if (firstLanguage === null) {
					firstLanguage = lang
				}
			}

			this.entity.translations = translations
			if (firstLanguage !== null) {
				this.translation.language = firstLanguage
				this.selectLanguage()
			}
			this.emptyMessage()
		},
		getDefaults(){
			let defaultParams = null;
			if(this.$route.params.recipient_subscriber_id) {
				this.setDefaultRecipients({id_subscribers: [this.$route.params.recipient_subscriber_id]})
			}else if(this.$route.params.duplicate_recipients){
				defaultParams = {duplicate_recipients_from_message: this.$route.params.duplicate_recipients};
			}else if(this.$route.params.forward_message){
				defaultParams = {forward_message: this.$route.params.forward_message};
			}

			if(defaultParams){
				this.entityService.getDefaultValues(defaultParams)
					.then((data)=>{
						if(data.defaults.recipients){
							this.setDefaultRecipients(data.defaults.recipients);
							delete data.defaults.recipients;
						}
						this.entity = {...this.entity, ...data.defaults};
						this.entity.translations = this.retypeTranslations(this.entity.translations);
						if(this.entity.translations && Object.keys(this.entity.translations).length){
							this.selectedLanguageId = Object.keys(this.entity.translations)[0];
							this.translation = this.entity.translations[this.selectedLanguageId];
						}
					});
			}
		},
		retypeTranslations(translations){
			let retypedTranslations = [];
			for (const key in translations) {
				let translation = translations[key]
				let lang = iso6392ToIso6391(key)
				retypedTranslations[lang] = {
					"subject": translation.subject,
					"short_body": translation.short_body,
					"body": translation.body
				}
			}
			return retypedTranslations;
		},
		setDefaultRecipients(recipients){
			if(recipients.all_available){
				this.sendToAll = true;
			} else if(recipients.id_subscribers){
				this.entity.recipients.id_subscribers = recipients.id_subscribers;
			}
			this.onRecipientsChange();
		},
		_processDetailErrorMessage(error) {
			return this.processErrorMessage(error)
		},
		processErrorMessage(error) {
			let nameError = null
			let translationError = null
			let languageError = null
			let subjectError = null
			let shortBodyError = null

			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Message\'s name is missing.')) {
					nameError = this.$gettext('Zadejte název')
				}
				if (this._.includes(errorMessage, 'Message translation\'s Subject is missing.')) {
					translationError = this.$gettext('Vyplňte všechny překlady.')
				}
				if (this._.includes(errorMessage, 'You have to fill either translation.body or translation.short_body')) {
					translationError = this.$gettext('Vyplňte alespoň tělo, nebo krátké tělo oznámení.')
				}
				if (this._.includes(errorMessage, "Missing translations.")) {
					languageError = this.$gettext('Zvolte alespoň jeden jazyk překladu.')
				}
				if (this._.includes(errorMessage, 'Message translation\'s Subject is too long - 255 letters at most are alowed.')) {
					subjectError = this.$gettext('Povolená délka je maximálně 255 znaků.')
				}
				if (this._.includes(errorMessage, 'Message translation\'s Short body is too long - 255 letters at most are alowed.')) {
					shortBodyError = this.$gettext('Povolená délka je maximálně 255 znaků.')
				}
			}.bind(this))

			if (nameError !== null) {
				this.$refs['messagenameref'].setForcedInvalid(true, nameError)
			} else {
				this.$refs['messagenameref'].setForcedInvalid()
			}

			if (subjectError !== null) {
				this.$refs['translationsubjectref'].setForcedInvalid(true, subjectError)
			} else {
				this.$refs['translationsubjectref'].setForcedInvalid()
			}

			if (shortBodyError !== null) {
				this.$refs['translationshortbodyref'].setForcedInvalid(true, shortBodyError)
			} else {
				this.$refs['translationshortbodyref'].setForcedInvalid()
			}

			if (translationError !== null) {
				return translationError
			}

			if (languageError !== null) {
				return languageError
			}

			return error['error_message']
		},
		reset() {
			this.$refs['messagenameref'].setForcedInvalid()
			this.$refs['translationsubjectref'].setForcedInvalid()
			this.$refs['translationshortbodyref'].setForcedInvalid()
			this.$refs['translationbodyref'].setForcedInvalid()
			this.$refs['translationlanguageref'].setForcedInvalid()
		},
		_afterUpdateEntityActions() {
			this.reset()
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/messages/mixins/messages.js